import React from "react";
import "./helpers/devAutoLogin";
import "./helpers/staleImpersonation";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";

import App from "./components/App";
// import reportWebVitals from "./reportWebVitals";
// import * as serviceWorker from './serviceWorker';
import store from "./store";
import "./index.css";
import { initColorMode } from "./helpers/colorMode";
import {
  stripCacheBustParam,
  unregisterLeftoverServiceWorkers,
} from "./helpers/hardReloadApp";
import { redirectStationToTenantHost } from "./helpers/stationTenantRedirect";

// Drop leftover CRA service workers (register() is no longer called) so they
// cannot keep serving a stale index.html. Leaves localStorage / cookies alone.
unregisterLeftoverServiceWorkers().catch(() => {});
stripCacheBustParam();

// NOTE: Apollo (`ApolloProvider`) and Polaris (`AppProvider` + its global CSS)
// used to wrap the whole app here, which forced `@apollo/client`, `@shopify/
// polaris` and the Polaris stylesheet into `main.js`/`main.css` on EVERY route
// (including the full-screen customizer, which uses neither). They now live in
// lazily-loaded route boundaries (`AdminProviders` / `ApolloBoundary`) mounted
// in `App.js`, so they only load for the routes that actually need them.

// Apply the persisted light/dark preference (or follow the OS scheme)
// BEFORE React renders so the first paint already carries the correct
// `data-theme` on <html> — no flash of the wrong theme. Also wires the
// `prefers-color-scheme` listener for the "system" preference.
initColorMode();

// Diagnostic marker for the riverr design-palette rebuild
// (page #F8F7F4 / sidebar #ECEAE3 / active #DAD7CC / cards
// #FFFFFF / text #2A2825). When debugging "I don't see the
// new colours" you can run `document.documentElement.dataset.riverrPalette`
// in DevTools — if it returns the version string below, the
// new bundle is reaching the browser and the issue is purely
// visual (the palette is intentionally low-contrast). If it
// returns `undefined`, the browser is serving stale cached
// JS or a service-worker is intercepting requests.
// Diagnostic marker for the riverr design directive build. Bump
// the version string when shipping a chrome-touching change so a
// quick `document.documentElement.dataset.riverrPalette` in
// DevTools confirms the new bundle is live.
//
//   v6 — `bg-transparent-not-active` (active pill fix)
//   v7 — `pill-no-border`            (drop active-pill ring)
//   v8 — `chrome-overhaul`           (full topbar + tokens + shell)
document.documentElement.dataset.riverrPalette = "v8-chrome-overhaul";

const root = ReactDOM.createRoot(document.getElementById("root"));

const renderApp = () =>
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </React.StrictMode>
  );

redirectStationToTenantHost().then((leaving) => {
  if (!leaving) renderApp();
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
// serviceWorker.register();
